import {WeaMaterialLib} from 'weaPortalPublic';
export default WeaMaterialLib;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/base/WeaMaterialLib.js